/* Etiquetas multiidoma en castellano. */
export default {
  "excursionNotFound.excursionNotFound": "The requested modality could not be found",
};
